import React from "react";
import { useNavigate } from "react-router-dom";
import "../all css/whattodosection.css";
const grey_tower_img = require("../../assets/grey_tower_img.png");

const what_to_do_img1 = require("../../assets/counselling.png");
const what_to_do_img2 = require("../../assets/immigration.png");
const what_to_do_img3 = require("../../assets/education loan.png");

const allWhatToDoBox = [
  {
    whatToDoName: "Counselling",
    whatToDoExtraName: `Varsity dreams are made into reality with our guidance.....`,
    whatToDoImg: what_to_do_img1,
  },
  {
    whatToDoName: "Immigration & Visa Services",
    whatToDoExtraName:
      "Backed by a strong team of immigration lawyers, your quest for quality .....",
    whatToDoImg: what_to_do_img2,
  },
  {
    whatToDoName: "Education Loan Assistance",
    whatToDoExtraName: "We go above and beyond to get you the help you deserve...",
    whatToDoImg: what_to_do_img3,
  },
];

export const WhatToDoSection = () => {
  const navigate = useNavigate();

  const handleReadMore = (navigateTo) => {
    if (navigateTo === "Counselling") {
      navigate("/CounsellingMainPage");
    }
    if (navigateTo === "Immigration & Visa Services") {
      navigate("/ImmigrationMainPage");
    }
    if (navigateTo === "Education Loan Assistance") {
      navigate("/EducationLoanMainPage");
    }
    // navigate("/CounsellingReadMoreSection");
  };

  return (
    <section className="main_what_to_do_section">
      <div className="main_under_wht_to_do_section">
        <div className="title_and_subtitle_section">
          <p
            className="title_text wow pulse animated"
            data-wow-delay="500ms"
            data-wow-iteration="infinite"
            data-wow-duration="1s"
          >
            WHAT WE DO ?
          </p>
          <p className="subtitle_what_to_do_text">
            Inspiring & Innovating educational solutions. 
          </p>
          <p className="extra_text_wht_to_do_text">
          From personalized counselling and application processing to streamlining immigration channels, we are committed to refining your overseas educational experience like none other. 
          </p>
        </div>
        <div className="all_whattodo_box_container">
          {allWhatToDoBox.map((perWhatToBox) => {
            return (
              <div
                className="each_what_to_do_box_container"
                key={Math.random()}
              >
                <p>{perWhatToBox.whatToDoName}</p>
                <p className="extra_text_what_to_do_box">
                  {perWhatToBox.whatToDoExtraName}
                </p>
                <button
                  className="read_more_btn_what_to_do"
                  onClick={() => handleReadMore(perWhatToBox.whatToDoName)}
                >
                  Read more
                </button>
                <div
                  className="img_tower_container wow bounce"
                  data-wow-duration=".5s"
                >
                  <img
                    src={grey_tower_img}
                    alt="tower_img"
                    className="grey_tower_img"
                  />
                </div>

                <div
                  className="white_circle_img_container wow fadeInUpBig"
                  data-wow-delay=".5s"
                  data-wow-duration=".5s"
                >
                  <img
                    src={perWhatToBox.whatToDoImg}
                    alt="tower_img"
                    className="_icon_img1"
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
